class CartModalController {
    constructor($session, $cart, $uibModalInstance, options) {
        let $ctrl = this;
        $cart.bus.validationErrors = {};
        $ctrl.modal = $ctrl.$uibModalInstance = $uibModalInstance;
        $ctrl.$dismiss = $uibModalInstance.dismiss;
        $ctrl.$close = $uibModalInstance.close;
        $ctrl.$cart = $cart;
        $ctrl.$session = $session;
        $ctrl.bus = $cart.bus;
        $ctrl.request = {};
        angular.extend($ctrl, options);
        $ctrl.title = options.title || 'Create a cart...';

    }

    submit() {
        let $ctrl = this;
    }
}

export default CartModalController